module.exports = __webpack_public_path__ + "img/myclinic-rec-1.586df1e1.png";